import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { formatApiErrorDetail } from "@/lib/seo";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated. Please sign in.");
      navigate("/login");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-background">
      <div className="w-full max-w-sm">
        <Logo markSize={44} />
        <h1 className="font-display text-2xl font-bold text-foreground mt-8">Set a new password</h1>
        {!token ? (
          <p className="text-sm text-red-400 mt-2">Missing or invalid reset link.</p>
        ) : (
          <form onSubmit={submit} className="mt-8 space-y-4">
            <div>
              <Label className="text-xs text-muted-foreground">New password</Label>
              <Input type="password" required minLength={8} value={password} onChange={(e) => setPassword(e.target.value)} data-testid="reset-password" className="mt-1.5 bg-secondary/50 border-border" />
            </div>
            {error && <p className="text-sm text-red-400">{error}</p>}
            <Button type="submit" disabled={loading} data-testid="reset-submit" className="w-full bg-primary text-white font-semibold rounded-full h-11">
              {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "UPDATE PASSWORD"}
            </Button>
          </form>
        )}
        <Link to="/login" className="mt-4 block text-sm text-muted-foreground hover:text-primary">← Back to sign in</Link>
      </div>
    </div>
  );
}
